import { faCircleInfo } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { Trans } from '@lingui/react/macro';

import { StatusMessage } from '@/common-components/elements/StatusMessage/StatusMessage';

export const InformationCollectedResult = () => {
  return (
    <StatusMessage
      icon={faCircleInfo}
      iconClassName="vai-h-12 vai-w-12 vai-text-blue-600"
      heading={<Trans>Information Collected</Trans>}
      headingClassName="vai-text-xl vai-font-bold vai-text-blue-600"
      message={<Trans>Thank you, our sales team will reach out shortly.</Trans>}
      messageClassName="vai-text-sm vai-text-blue-700"
      className="vai-flex vai-flex-col vai-items-center vai-space-y-2 vai-rounded-lg vai-border-2 vai-border-blue-300 vai-bg-blue-50 vai-px-6 vai-py-8"
    />
  );
};
